import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

import AppButton from 'components/FormsUI/AppButton/appButton';

export default function ConstantRow({ item, onEdit, onSubmitted }) {
    const [message, setMessage] = useState("");
    const [selectedItem, setSelectedItem] = useState({});
    const [show, setShow] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errMessage, setErrMessage] = useState("");
    const handleShow = (item, action) => {
        setMessage('Are you sure you want to cancel the constant?');
        setSelectedItem(item);
        setShow(true);
    }
    const handleClose = () => setShow(false);

    const HandleDeleteConstant = async () => {
        onSubmitted(selectedItem, "delete");
        setShow(false);
    }
    return (

        <div key={item.id} className="row border-bottom" style={{ paddingTop: "5px" }}>
            <div className="col-md-2">
                {item.constantName}
            </div>
            <div className="col-md-2">
                {item.constantValue}
            </div>
            <div className="col">
                {item.constantDescription}
            </div>
            <div className="col-2">
                <AppButton action={onEdit} label="Update" classes="margingRight" ></AppButton>
                <AppButton action={() => handleShow(item, "cancel")} label="Delete" ></AppButton>
                {setSuccessMessage !== undefined ? <div>{successMessage}</div> : null}
                {setErrMessage !== undefined ? <div>{errMessage}</div> : null}
            </div>

            <div>
                <Modal show={show} >
                    <Modal.Header>
                        <Modal.Title>Delete User</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{message}</Modal.Body>
                    <Modal.Footer>
                        <div className='col-2'>
                            <AppButton action={() => HandleDeleteConstant(selectedItem)} label="Yes" isBlock={true}></AppButton>
                        </div>
                        <div className='col-2'>
                            <AppButton action={handleClose} label="No" color="secondary" isBlock={true}></AppButton>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>

    )
}